var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',_vm._l((_vm.list),function(item,index){return _c('v-sheet',{key:index,staticClass:"ma-4",attrs:{"id":item.title,"color":"white","rounded":"","elevation":"0"}},[_c('v-subheader',[_c('b',[_vm._v(_vm._s(item.title))])]),_c('CenterApp',{attrs:{"data":item.apps}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }